/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Wij gebruiken cookies voor het volgen van bezoeken aan onze website, wij slaan geen persoonlijke informatie op.',
    cookiesAccept: 'Cookies accepteren',
    cookiesDeny: 'Cookies afwijzen',
    tabFAQs: 'Veelgestelde vragen',
    tabSupport: 'Ondersteuning',
    tabHistory: 'Geschiedenis',
    tabReviews: 'Verhalen',
    tabTraining: 'Training',
    tabUserTraining: 'Gebruikerstraining',
    tabHcpTraining: 'Zorgtraining',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Zwangerschap',
    tabAbout: 'Over ons',
    tabNews: 'Nieuws',
    tabCareers: 'Vacatures',
    tabOrders: '',
    tabNotifications: 'Meldingen',
};
